/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum FrameVariation {
    Panel = 0,
    Window = 1,
    TiltAndTurnWindowLeft = 2,
    TiltAndTurnWindowRight = 3,
    CenterPivotWindow = 4,
    TopHungWindow = 5,
}
